import { render, staticRenderFns } from "./CText.vue?vue&type=template&id=0d452430"
import script from "./CText.vue?vue&type=script&lang=js"
export * from "./CText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d452430')) {
      api.createRecord('0d452430', component.options)
    } else {
      api.reload('0d452430', component.options)
    }
    module.hot.accept("./CText.vue?vue&type=template&id=0d452430", function () {
      api.rerender('0d452430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CText.vue"
export default component.exports